/**
 * Provenance of a resolved deadline offset (postal transit / payment term /
 * buffer / grace period) of a dunning level: is the value maintained on the
 * level configuration, or is it not configured and therefore does not apply
 * (0 days)?
 *
 * There are no system default offsets any more (business rule): an empty
 * configuration field means the offset does not apply — it is NOT filled in
 * from a hidden default.
 *
 * Mirrors backend enum {@code com.mvs.backend.bd.enums.BdDunningOffsetSource}.
 * Ordinal mapping (MUST match the backend enum):
 *   0 = CONFIGURED
 *   1 = NOT_CONFIGURED
 *
 * @ticket bd-dunningtype-overview
 */
export enum BdDunningOffsetSource {
    CONFIGURED,
    NOT_CONFIGURED
}

/**
 * German UI labels for BdDunningOffsetSource values.
 * CONFIGURED(0)="Konfiguriert", NOT_CONFIGURED(1)="nicht konfiguriert".
 */
export const BD_DUNNING_OFFSET_SOURCE_LABELS: Record<BdDunningOffsetSource, string> = {
    [BdDunningOffsetSource.CONFIGURED]: 'Konfiguriert',
    [BdDunningOffsetSource.NOT_CONFIGURED]: 'nicht konfiguriert'
};
